var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGameContext } from "../../../game/GameContext/GameContext";
import InfinityIcon from "../../../assets/infinity";
import Button from "../../../ui/Button/Button";
import { InputButtonWrapper } from "../../../ui/Input/Input.styled";
import { useMemo } from "react";
var BetCountButtons = function () {
    var _a = useGameContext(), setAutoPlayOptions = _a.setAutoPlayOptions, inProgress = _a.inProgress, autoPlayInProgress = _a.autoPlayInProgress, controlPanelDisabled = _a.controlPanelDisabled;
    var isDisabled = useMemo(function () { return inProgress || autoPlayInProgress || controlPanelDisabled; }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    var handleClick = function (betCount) { return function () {
        setAutoPlayOptions(function (prevOptions) { return (__assign(__assign({}, prevOptions), { betCount: betCount })); });
    }; };
    return (_jsxs(InputButtonWrapper, { children: [_jsx(Button, { variant: "inputButton", onClick: handleClick(-1), disabled: isDisabled, children: _jsx(InfinityIcon, {}) }), _jsx(Button, { variant: "inputButton", onClick: handleClick(10), disabled: isDisabled, children: "10" }), _jsx(Button, { variant: "inputButton", onClick: handleClick(100), disabled: isDisabled, children: "100" })] }));
};
export default BetCountButtons;
//# sourceMappingURL=BetCount.buttons.js.map